// Real IVI YouTube playlists (scraped from volunteering.org.au/about/videos/)
const thumb = (id) => `/assets/img/yt-${id}.jpg`;

const v = (id, title, duration) => ({ id, title, duration, poster: thumb(id) });

export const VIDEO_PLAYLISTS = [
  {
    key: "reviews",
    label: "Volunteer Reviews",
    blurb: "Hear it straight from our volunteers.",
    videos: [
      v("xld1IMpY3Yc", "IVI Reviews Volunteer Experiences", "3:02"),
      v("zeOU4IKeUBc", "IVI Our Mission", "1:11"),
      v("3pnP5p_ciYg", "Volunteers Making a Difference in Vietnam", "2:24"),
      v("Oswwv4XfFqs", "Be Inspired and Connect with the Beautiful People of Bali!", "1:32"),
    ],
  },
  {
    key: "bali",
    label: "Bali",
    blurb: "Turtles, classrooms, stray dogs and construction in Ubud.",
    videos: [
      v("Oswwv4XfFqs", "Be Inspired and Connect with the Beautiful People of Bali!", "1:32"),
      v("qGlLeXrwHYk", "IVI Bali Turtle Conservation", "1:57"),
      v("GhB_sFIj1V0", "Bali Turtle Conservation Project", "1:06"),
      v("l20V70cpdF0", "Volunteers Helping to Rehabilitate Stray Dogs in Ubud, Bali", "0:55"),
      v("vnCcHeKs9Qw", "IVI Bali English Teaching Project, Ubud", "1:01"),
      v("GPw9d2zOkYU", "Volunteer Kindergarten Teaching in Bali with IVI", "1:04"),
      v("obh-NqyedSU", "Community Construction Volunteer Projects in Ubud, Bali", "0:57"),
    ],
  },
  {
    key: "vietnam",
    label: "Vietnam",
    blurb: "Hospitals, kindergartens and nutrition in Ho Chi Minh & Phan Thiet.",
    videos: [
      v("3pnP5p_ciYg", "Volunteers Making a Difference in Vietnam", "2:24"),
      v("9MXF1Q3RoF0", "Food & Nutrition Program Vietnam", "0:51"),
      v("VQYXQrAPgko", "Vietnam Hospital Internships for Medicine Students and Graduates", "0:44"),
      v("4mGdsxEwDVA", "Special Needs Volunteering", "0:44"),
      v("nwb4sB4aGLk", "Teaching English in Vietnam", "0:50"),
      v("f2PVzvC14Fc", "Volunteers Helping Vietnamese Kindergartens", "0:50"),
    ],
  },
  {
    key: "about",
    label: "About IVI",
    blurb: "Who we are and why we do this.",
    videos: [v("zeOU4IKeUBc", "IVI Our Mission", "1:11")],
  },
];
